exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dataprotection-tsx": () => import("./../../../src/pages/dataprotection.tsx" /* webpackChunkName: "component---src-pages-dataprotection-tsx" */),
  "component---src-pages-events-js": () => import("./../../../src/pages/events.js" /* webpackChunkName: "component---src-pages-events-js" */),
  "component---src-templates-events-index-js": () => import("./../../../src/templates/events/index.js" /* webpackChunkName: "component---src-templates-events-index-js" */)
}

